import React from 'react'

export const CloseIconV3 = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.7725 2.88202C20.2819 2.37266 21.1086 2.37266 21.618 2.88202C22.1273 3.39137 22.1273 4.21814 21.618 4.72749L4.22749 22.118C3.71814 22.6273 2.89137 22.6273 2.38202 22.118C1.87266 21.6086 1.87266 20.7819 2.38202 20.2725L19.7725 2.88202Z"
      fill="#2C3490"
      stroke="#2C3490"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.38202 2.88202C2.89137 2.37266 3.71814 2.37266 4.22749 2.88202L21.618 20.2725C22.1273 20.7819 22.1273 21.6086 21.618 22.118C21.1086 22.6273 20.2819 22.6273 19.7725 22.118L2.38202 4.72749C1.87266 4.21814 1.87266 3.39137 2.38202 2.88202Z"
      fill="#2C3490"
      stroke="#2C3490"
      strokeWidth="0.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
